import React, { useEffect, useRef, useState } from 'react'
import { Box } from '@mui/material'
import moment from 'moment'

import ModifyStyle from './PlanStyle'
import MessageContext from '../../providers/GlobalTip'
import { HotKeysContext } from '../../providers/HotKeysProvider'

import PlanEditTable from './PlanEditTable'

/**
 * Minimal embed wrapper around legacy PlanEditTable.
 *
 * This reuses the existing monthly planning grid inside the new weekly UI.
 * Intentionally omits the left panels (copy/target/chart) to keep the weekly UI simple.
 */
function LivePlanEditEmbed(props) {
  const {
    epochMonth,
    client,
    planId,
    locationClassId,
    nextClass,
    nextLocation,
    savingPlan = false,
    onUpdate,
    forceReload = false,
    setForceReload = () => {},
    onFuturePlanDetected,
    onTabs,
    onChartData,
  } = props

  const messageContext = MessageContext.useMessage()

  const [displayMonths, setDisplayMonths] = useState([])
  const [tabs, setTabs] = useState([])
  // chartData isn't rendered in this embed, but we still capture it so the parent can use it.
  const [chartData, setChartData] = useState(new Map())
  const intervalRef = useRef()

  useEffect(() => {
    return () => {
      clearInterval(intervalRef.current)
    }
  }, [])

  useEffect(() => {
    if (!displayMonths.length && epochMonth) {
      const startMonth = moment(`${epochMonth}01`, 'YYYYMMDD')
      const months = []
      for (let i = 0; i < 12; i++) {
        months.push(moment(startMonth).add(i, 'months').format('MMM'))
      }
      setDisplayMonths(months)
    }
  }, [epochMonth, displayMonths.length])

  const hotKeysContext = {
    updatePlanV2: onUpdate,
    nextLocation,
    nextClass,
  }

  useEffect(() => {
    if (typeof onTabs === 'function') onTabs(tabs)
  }, [tabs, onTabs])

  useEffect(() => {
    if (typeof onChartData === 'function') onChartData(chartData)
  }, [chartData, onChartData])

  return (
    <Box sx={ModifyStyle.rightSection}>
      <Box sx={{ pb: 2 }}>
        <HotKeysContext.Provider value={hotKeysContext}>
          <PlanEditTable
            nextClass={nextClass}
            nextLocation={nextLocation}
            savingPlan={savingPlan}
            onUpdate={onUpdate}
            client={client}
            planId={planId}
            locationClassId={locationClassId}
            epochMonth={epochMonth}
            setChartData={setChartData}
            displayMonths={displayMonths}
            messageContext={messageContext}
            tabs={tabs}
            setTabs={setTabs}
            overridePlanData={null}
            forceReload={forceReload}
            setForceReload={setForceReload}
            onFuturePlanDetected={onFuturePlanDetected}
          />
        </HotKeysContext.Provider>
      </Box>
    </Box>
  )
}

export default LivePlanEditEmbed
